/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { get, find } from 'lodash';

/**
 * Internal dependencies
 */
import Card from 'components/card';
import { requestPlansIfNotRequested } from 'state/universal-importer-plans/actions';
import { getAllUniversalImporterPlans, requestingUniversalImporterPlans } from 'state/universal-importer-plans/selectors';
import { swapSubscription } from 'state/subscriptions/actions';
import { getCurrentUniversalImporterId, getCurrentUniversalImporterPlanId, getCurrentUniversalImporter } from 'state/current-universal-importer/selectors';
import { successNotice } from 'state/notices/actions';
import { requestAddonsIfNotRequested } from 'state/addons/actions';
import Loader from './loader';
import { getAllAddons } from 'state/addons/selectors';
import Plan from './plan';
import Preloader from 'components/preloader';
import cscom from 'lib/customer-site-api';
import cb from 'lib/chargebee';
import Money from 'components/money';
import ConfirmNewPlanAlert from './confirm-new-plan-alert'; // Import
import { requestCurrentUniversalImporter } from 'state/current-universal-importer/actions';
import { getCurrentUser } from 'state/current-user/selectors';
import { requestCouponsIfNotRequested } from 'state/coupons/actions';
import { Box, Stack } from '@towersystems/towersystems-design-system';
import FlashMessage from 'components/flash-message';
import page from 'page';

/**
 * Style dependencies
 */
import './styles.scss';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const SelectUniversalImporterPlan = (props) => {
    const universalImporterPlans = props.universalImporterPlans;
    const [submitting, setSubmitting] = useState(false);
    const [values, setValues] = useState({});

    const onChange = (value) => {
        //if (!props.visualDeckSubscriptionId) {
            return newPlanSubscription(value);
        //}

        let plan = find(universalImporterPlans, { id: value });
        let addon = resolveLicenseAddon(plan);

        confirmAlert({
            title: 'Subscribe to Universal Importer',
            message: 'Select a Universal Importerplan.',
            submitting,
            closeOnEscape: false,
            closeOnClickOutside: false,
            customUI: ({ onClose }) => (
                <ConfirmNewPlanAlert
                    currentUniversalImporter={props.currentUniversalImporter}
                    newPlanId={plan.id}
                    plan={plan}
                    addon={addon}
                    onClose={onClose}
                    onSubmit={() => handleSubscribe(value)}
                />
            ),
        });
    };

    useEffect(() => {
        props.requestUniversalImporterPlans();
        props.requestAddons();
        props.requestCoupons();
    }, []);

    const handleSubscribe = (value) => {
        setSubmitting(true);

        return props
            .swapSubscription(props.universalImporterSubscriptionId, value)
            .then((s) =>
                props.successNotice(
                    'Your Universal Importer subscription will be updated at the end of the current billing period.',
                ),
            )
            .then(() => props.afterSuccess && props.afterSuccess())
            .finally(() => setSubmitting(false));
    };

    const handleSubmit = (value) => {
        setSubmitting(true);
        return props
            .swapSubscription(props.universalImporterSubscriptionId, value)
            .then((s) =>
                props.successNotice(
                    'Your Universal Importer subscription will be updated at the end of the current billing period.',
                ),
            )
            .then(() => props.afterSuccess && props.afterSuccess())
            .finally(() => setSubmitting(false));
    };

    const newPlanSubscription = (planId) => {
        cb.openCheckout({
            hostedPage: () => cscom.hostedPage().newPlanSubscription(planId),
            error: (e) => console.log(e),
            //close: () => { window.location.reload(); },
            success: () => {
                props.requestCurrentUniversalImporter();
                props.successNotice('Your Universal Importer subscription has been created.');
                page.redirect('/dashboard/universal-importer');
            },
        });
    };

    const resolveLicenseAddon = (plan) => {
        return null;
    };

    if (props.requesting) {
        return <Loader />;
    }

    return (
        <form onSubmit={handleSubmit}>
            <Box>
                <Stack space='xxlarge'>
                    {universalImporterPlans.map((plan, i) => {
                        return (
                                <Plan
                                key={plan.id}
                                plan={plan}
                                onClick={() => onChange(plan.id)}
                                disabled={
                                    !(props.currentUniversalImporter && props.currentUniversalImporter.status == 'cancelled')
                                        ? plan.id == props.universalImporterPlanId
                                        : null
                                }
                                licenseAddon={resolveLicenseAddon(plan)}
                                numberLicenses={props.currentUser.additionalLicenses}
                            />
                        );
                    })}
                </Stack>
            </Box>
        </form>
    );
};

export default connect(
    (state) => ({
        universalImporterPlans: getAllUniversalImporterPlans(state),
        addons: getAllAddons(state),
        universalImporterSubscriptionId: getCurrentUniversalImporterId(state),
        universalImporterPlanId: getCurrentUniversalImporterPlanId(state),
        currentUniversalImporter: getCurrentUniversalImporter(state),
        currentUser: getCurrentUser(state),
        requesting: requestingUniversalImporterPlans(state),
    }),
    {
        requestUniversalImporterPlans: requestPlansIfNotRequested,
        requestCurrentUniversalImporter,
        requestCoupons: requestCouponsIfNotRequested,
        swapSubscription,
        successNotice,
        requestAddons: requestAddonsIfNotRequested,
    },
)(SelectUniversalImporterPlan);
